import {
  DesktopTower,
  Bank,
  Crown,
  UsersFour,
  ShieldCheck,
  Globe,
} from "@phosphor-icons/react";

export const AboutData = [
  {
    AboutIcon: <DesktopTower size={25}/>,
    AboutDesc: "Informatique",
    AboutLink:"/domaines/informatique",
    id:"1"
  },
  {
    AboutIcon: <Bank size={25}/>,
    AboutDesc: "Finances/Budjets",
    AboutLink:"/domaines/finances",
    id:"2"
  },
  {
    AboutIcon: <Crown size={25}/>,
    AboutDesc: "Leadership",
    AboutLink:"/domaines/enforcement-des-competence",
    id:"3"
  },
  {
    AboutIcon: <UsersFour size={25}/>,
    AboutDesc: "Ressources Humaines",
    AboutLink:"/domaines/ressources-humaines",
    id : "4"
  },

  {
    AboutIcon: <ShieldCheck size={25}/>,
    AboutDesc: "Organisation et réforme du secteur de la sécurité",
    AboutLink:"/domaines/organisation",
    id:"5"
  },
  {
    AboutIcon: <Globe size={25}/>,
    AboutDesc: "Relations Internationales – Sécurité – Maintien de la paix – Stratégies",
    AboutLink:"/domaines/analyse-strategique-securitaire",
    id:"6"
  },
];
